import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Layout,
  Form,
  Button,
  Card,
  Row,
  Col,
  Breadcrumb,
  Space,
  Input,
} from "antd";

import { useBackend } from "backend/useBackend";
import TextArea from "antd/es/input/TextArea";

const { Content } = Layout;

const endpoint = "quotes";

const Confirm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { addItem } = useBackend();

  const onFinish = (values) => {
    const payload = {
      quotes: JSON.parse(values.quotes),
    };
    // console.log(payload)
    addItem(`${endpoint}/bulk`, payload, {
      // redirectTo: endpoint,
      loader: true,
      msg: {
        loading: "Quotes Adding...",
      },
    }).then((data) => {
      navigate("/scraping/url");
    });
  };

  const onFinishFailed = (data) => console.log(data);

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Quotes</Breadcrumb.Item>
        <Breadcrumb.Item>Add By Url</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={12}>
        <Col md={24}>
          <Card title="Quotes">
            <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                quotes: JSON.stringify(location.state.items, null, 2),
                count: location.state.items.length || 0,
                url: location.state.url
              }}
              size={"large"}
            >
              <Form.Item
                className="mb-2"
                label="Quotes URL"
                name="url"
                size={"large"}
              >
                <Input />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Quotes Count"
                name="count"
                size={"large"}
              >
                <Input />
              </Form.Item>
              <Form.Item>
                <Row justify="end" style={{ marginTop: "2em" }}>
                  <Col>
                    <Space size="small">
                      <Button type="primary" htmlType="submit" size="large">
                        Save
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Quotes List"
                name="quotes"
                rules={[{ required: true, message: "Quotes is required" }]}
                size={"large"}
              >
                <TextArea
                  rows={100}
                  // defaultValue={location.state}
                  // defaultValue={JSON.stringify(location.state, null, 2)}
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default Confirm;
